/**
 * Number of applications by five underwriting/ re-underwriting results, by age and sex of Insured Person
 */
import { hasLoadings, hasExclusions } from "@/modules/reports/schemas/utils/"
import get from "lodash.get"
import dayjs from "dayjs"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 12 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 2, c: 1 }
		},
		{
			s: { r: 1, c: 2 },
			e: { r: 1, c: 6 }
		},
		{
			s: { r: 1, c: 7 },
			e: { r: 1, c: 11 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template 01 - Number of applications by five underwriting/ re-underwriting results, by age and sex of Insured Person"
	],
	["Age", "Sex", "Standard Plan", "", "", "", "", "Flexi Plan"],
	[
		"",
		"",
		"Standard Offer",
		"Offer with Premium Loading Only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Decline",
		"Standard Offer",
		"Offer with Premium Loading Only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Decline"
	]
]

// Return calculated age
const getAge = policy => {
	const dateOfBirth = get(policy, "insured[0].dateOfBirth", null)
	const currentYear = dayjs().year()
	const yearOfBirth = dayjs(dateOfBirth).year()
	return currentYear - yearOfBirth
}

const rows = payload => {
	let output = []
	for (let i = 1; i < 100; i++) {
		output.push([
			i,
			"M",
			countStandardOffer(i, "male", payload),
			countOfferWithLoadings(i, "male", payload),
			countOfferWithExclusions(i, "male", payload),
			countOfferWithLoadingsAndExclusions(i, "male", payload),
			countDeclinedOffers(i, "male", payload),
			0,
			0,
			0,
			0,
			0
		])
	}
	for (let j = 1; j < 100; j++) {
		output.push([
			j,
			"F",
			countStandardOffer(j, "female", payload),
			countOfferWithLoadings(j, "female", payload),
			countOfferWithExclusions(j, "female", payload),
			countOfferWithLoadingsAndExclusions(j, "female", payload),
			countDeclinedOffers(j, "female", payload),
			0,
			0,
			0,
			0,
			0
		])
	}
	return output
}

const countStandardOffer = (age, gender, payload) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = get(policy, "insured[0].gender", null)
		if (
			policy.status === "QUOTING" &&
			insuredAge === age &&
			insuredGender === gender
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadings = (age, gender, payload) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = get(policy, "insured[0].gender", null)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)

		if (
			policy.status === "QUOTING" &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings === true &&
			exclusions === false
		) {
			return policy
		}
	}).length
}

const countOfferWithExclusions = (age, gender, payload) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = get(policy, "insured[0].gender", null)
		let exclusions = hasExclusions(policy)
		let loadings = hasLoadings(policy)
		if (
			policy.status === "QUOTING" &&
			insuredAge === age &&
			insuredGender === gender &&
			exclusions === true &&
			loadings === false
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadingsAndExclusions = (age, gender, payload) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = get(policy, "insured[0].gender", null)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		if (
			policy.status === "QUOTING" &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings &&
			exclusions
		) {
			return policy
		}
	}).length
}

const countDeclinedOffers = (age, gender, payload) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = get(policy, "insured[0].gender", null)
		if (
			policy.status === "REJECTED" &&
			insuredAge === age &&
			insuredGender === gender
		) {
			return policy
		}
	}).length
}
